// growthos/warchest-frontend/react-app/src/pages/scenario-builder/api/getActivityLog.ts
import { InfiniteData, useInfiniteQuery, UseInfiniteQueryResult } from "@tanstack/react-query";

import { components } from "@/@types/api";
import { INSIGHTS_BACKEND_URL } from "@/lib/axios";
import { axiosApi } from "@/Utils";

export type ActivityLogDTO = components["schemas"]["NewScenarioEvents"]["events"][number];
export type ActivityLogsResponse = components["schemas"]["NewScenarioEvents"];

export const getActivityLogs = async ({
  scenarioId,
  createdAt,
  limit = 4,
}: {
  scenarioId: string;
  createdAt?: string | undefined;
  limit?: number;
}): Promise<ActivityLogsResponse> => {
  return await axiosApi.get(`/api/v2/scenarios-new/${scenarioId}/activity-logs`, {
    baseURL: INSIGHTS_BACKEND_URL,
    params: {
      limit,
      ...(createdAt && { createdAt }),
      eventType: [
        "created",
        "completed",
        "approved",
        "archived",
        "cloned",
        "run",
        "comment",
        "error",
      ],
    },
  });
};

type UseInfiniteActivityLogsOptions = {
  scenarioId: string;
  limit?: number;
  refetchInterval?: number;
  enabled?: boolean;
};

export const useInfiniteActivityLogs = ({
  scenarioId,
  limit = 12,
  refetchInterval,
  enabled = true,
}: UseInfiniteActivityLogsOptions): UseInfiniteQueryResult<
  InfiniteData<ActivityLogsResponse>,
  Error
> => {
  return useInfiniteQuery({
    queryKey: ["activity-logs", scenarioId, limit],
    queryFn: ({ pageParam = undefined }: { pageParam?: string }) =>
      getActivityLogs({
        scenarioId,
        createdAt: pageParam,
        limit: limit,
      }),
    getNextPageParam: (lastPage: any) => lastPage.nextCursor ?? false,
    initialPageParam: undefined,
    enabled,
    ...(refetchInterval !== undefined && { refetchInterval }),
  });
};
